import { path } from './index';
import { INavbarTabs } from '../components/NavbarTabs/NavbarTabs.type';


const navbarTabsPathList: string[] = [
  path.HOME,
  path.BLOCKS,
  path.TRANSACTION,
  path.SMART_CONTRACT,
];

const list: INavbarTabs[] = [
  {
    name: 'Home',
    path: path.HOME,
  },
  {
    name: 'Blocks',
    path: path.BLOCKS,
  },
  {
    name: 'Transactions',
    path: path.TRANSACTION,
  },
  {
    name: 'Smart Contracts',
    path: path.SMART_CONTRACT,
  },
];

const navbarTabs = { list, navbarTabsPathList };

export default navbarTabs;
